<template>
    <div class="pa-2">
        <div class="row">
            <div class="col-xs-2">
                <v-select :items="fsucursales" item-value="id" v-model="search" clearable label="Sucursal:" /> 
            </div>
            <div class="col-xs-2">
                <v-select :items="fpuntos" item-value="id" v-model="search" clearable label="Punto de venta:" /> 
            </div>
            <div class="col-xs-2">
                <v-select :items="festado_sistema" item-value="id" v-model="search" clearable label="Estado sistema:" /> 
            </div>
            <div class="col-xs-2">
                <v-select :items="festados" item-value="id" v-model="search" clearable label="Estado:" /> 
            </div>
            <div class="col-xs-2">
                <v-select :items="fdocsector" item-value="id" v-model="search" clearable label="Doc sector:" /> 
            </div>
            <div class="col-xs-2">
                <v-select :items="fduplis" item-value="id" v-model="search" clearable label="Duplicado:" /> 
            </div>
        </div> 

        
        <v-data-table
            :headers="headersSys"
            :items="desserts"
            :loading="loading" 
            :search="search"
            :custom-filter="custom_filter"
            dense
            xitems-per-page="150"
            xdisable-items-per-page
            xdisable-pagination 
            xhide-default-footer
        >

        <template v-slot:[`item.registradoSIN`]="{ item }">
            {{ item.registradoSIN?'SI':'NO' }}
        </template>

        <template v-slot:[`item.actions`]="{ item }">
            <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                <v-icon class="mr-2 green--text" small v-bind="attrs" v-on="on" @click="visualizarpdf(item)">
                    mdi-eye
                </v-icon>
                </template>
                <span> Ver PDF de Factura </span>
            </v-tooltip>
            <v-tooltip bottom v-if="$store.state.CARGO.id == 1 || $store.state.CARGO.id == 14">
            <template v-slot:activator="{ on, attrs }">
              <v-icon class="mr-2 green--text" small v-bind="attrs" v-on="on" @click="verificarestado(item)">
                mdi-check-decagram
              </v-icon>
            </template>
            <span> Verificar Estado </span>
          </v-tooltip>
          <v-tooltip bottom v-if="item.duplicado == 'SI' && item.inportal == '' && ($store.state.CARGO.id == 1 || $store.state.CARGO.id == 14)">
            <template v-slot:activator="{ on, attrs }">
              <v-icon 
                class="mr-0 red--text"
                small
                v-bind="attrs"
                v-on="on"
                @click="abrirAnularFactura(item)">
                mdi-delete
              </v-icon>
            </template>
            <span> Anular Factura </span>
          </v-tooltip>
        </template>

        </v-data-table>

        <Verfactura ref="verfactura" />
        <Anular ref="anularfactura" />
    </div>
</template>

<script>
import { headersSys,getIDsJEJEJE } from './utils.ts'
import xaxios from '@/xaxios';
import Verfactura from '@/views/rfacturascv/verfactura.vue';
import Anular from '@/views/recibos/AnularFE.vue';

export default {
    components:{ Verfactura,Anular },
    data: () => ({ 
        headersSys,
        loading: false,
        desserts:[],
        search: '',
        nit:{},
        fsucursales: [
            {id:'sucursal-0', text:'Sucursal 0'},
            {id:'sucursal-1', text:'Sucursal 1'},
        ],
        fpuntos: [
            {id:'punto-0', text:'Punto 0'},
            {id:'punto-1', text:'Punto 1'},
            {id:'punto-2', text:'Punto 2'},
            {id:'punto-3', text:'Punto 3'},
        ],
        festado_sistema: [
            {id:'estadosys-true', text:'Registrado'},
            {id:'estadosys-false', text:'No registrado'}, 
        ],
        festados: [
            {id:'estado-VALIDA', text:'VALIDA'}, 
        ],
        fdocsector: [
            {id:'docsector-1', text:'Sector 1'}, 
            {id:'docsector-3', text:'Sector 3'}, 
            {id:'docsector-11', text:'Sector 11'}, 
        ],
        fduplis: [
            {id:'duplicados-SI', text:'Duplicados'}, 
            {id:'duplicados-', text:'No Duplicados'},  
        ]
    }),
    methods:{ 
        async get_datos(endpoint,mes, anio,nit){
            this.desserts = [];
            this.loading = true;
            this.nit = nit;
            // window.console.log('----->>>>', nit);
            let url = process.env.VUE_APP_FACT_REST+`/facturacion/facturas/${endpoint}?mes=${mes}&anio=${anio}`;
            let config = {
                method: 'get',
                url: url,
                headers: { 'Content-Type': 'application/json',apikey: nit.apikey },
            };
            let res = await xaxios.request(config).then(({data})=>data).catch(e=>e)
            

            if(res && res.data ){
                const sucursalesMap = new Map();
                const puntosMap = new Map();
                const estadosMap = new Map();
                const docSectorMap = new Map();
                const ids = [];

                for(let i=0;i<=res.data.length;i++){
                    let x = res.data[i];
                    if(!x) continue;
                    x.inportal = '';
                    x.duplicado = '';
                    let o = {id:'sucursal-'+x.idSucursal,text:'Sucursal '+x.idSucursal};
                    sucursalesMap.set(o.id, o);
                    
                    let o2 = {id:'punto-'+x.idpuntoVenta,text:'Punto '+x.idpuntoVenta};
                    puntosMap.set(o2.id, o2);
                    
                    let o3 = {id:'estado-'+x.estado,text:''+x.estado};
                    estadosMap.set(o3.id, o3);
                    
                    let o4 = {id:'docsector-'+x.codigoDocumentoSector,text:''+x.codigoDocumentoSector};
                    docSectorMap.set(o4.id, o4);

                    ids.push( parseInt(x.documentoOrigen) );
                }

                // academicoesamdb.pagos_inscripcion 
                // pi2 on v.documento_origen =pi2.id and v.id =pi2.factura_id
                let dus = await getIDsJEJEJE(ids);
                for(let i=0;i<dus.length;i++){
                    let x = dus[i];
                    let pi2id = x.id;
                    let pi2factura_id = x.factura_id;

                    let r = res.data.find(v=>v.documentoOrigen== pi2id && v.id == pi2factura_id);
                    if(r){
                        r.inportal = 'SI'
                    } 

                    
                    /*let count = res.data.filter(v => v.documentoOrigen == pi2id && (v.estado == "VALIDADA" || v.estado=='VALIDA') ).length;
                    if(r && count > 1){
                        window.console.log('----->>',pi2id, count,r);
                        r.duplicado = 'SI'
                    }*/
                }

                for(let i=0;i<dus.length;i++){
                    let x = dus[i];
                    let pi2id = x.id; 
                    let counts = res.data.filter(v => v.documentoOrigen == pi2id && (v.estado == "VALIDADA" || v.estado=='VALIDA') );
                    if(counts.length > 1){
                        for(let i=0;i<counts.length;i++){
                            let r = counts[i];
                            r.duplicado = 'SI'
                        }
                    }
                    
                }

                window.console.log('--->dus',dus, res.data);

                this.fsucursales = Array.from(sucursalesMap.values());
                this.fpuntos = Array.from(puntosMap.values());
                this.festados = Array.from(estadosMap.values());
                this.fdocsector = Array.from(docSectorMap.values());
                
                this.desserts = res.data;
            }
            this.loading = false;
        },
        custom_filter(value,search,item){
            if(!search) return true;

            if((search+'').startsWith('sucursal-')){
                let id = (search+'').split('-')[1];
                if(item.idSucursal == id) return true;
                return false;
            }
            else if((search+'').startsWith('punto-')){
                let id = (search+'').split('-')[1];
                if(item.idpuntoVenta == id) return true;
                return false;
            }
            else if((search+'').startsWith('estadosys-')){
                let id = (search+'').split('-')[1];
                // window.console.log('item.registradoSIN == id',item.registradoSIN+'',id);
                if(item.registradoSIN+'' == id) return true;
                return false;
            }
            else if((search+'').startsWith('estado-')){
                let id = (search+'').split('-')[1];
                if(item.estado == id) return true;
                return false;
            }
            else if((search+'').startsWith('docsector-')){
                let id = (search+'').split('-')[1];
                if(item.codigoDocumentoSector == id) return true;
                return false;
            } 
            else if((search+'').startsWith('duplicados-')){
                let id = (search+'').split('-')[1];
                if(item.duplicado == id) return true;
                return false;
            } 
            
        },
        visualizarpdf(item) {
            let fact = { venta: item, xapikey: this.nit.apikey };
            this.$refs.verfactura.openmodal(fact);
        },
        verificarestado(item) {
            let vue = this;
            let opt = {
                verification: 'si',
                verificationHelp: 'Escriba "[+:verification]" para Sincronizar Catalogo.',
                okText: 'Verificar',
                cancelText: 'cancelar',
                backdropClose: false,
                animation: 'bounce',
                loader: true,
                type: 'classic',
            };
            var message = {
                title: 'Confirmar',
                body: '<br> <b>NOTA:</b> Esta accion es irreversible.',
            };
            this.$dialog
            .confirm(message, opt)
            .then(function (dialog) {
                vue.verificarestado2(item, dialog);
            })
            .catch(function () {});
        },
        verificarestado2(item, dialog) {
            let vue = this;
            var config = {
                method: 'get',
                url: `${process.env.VUE_APP_FACT_REST}/facturacion/ventas/verificar/${item.id}`,
                headers: {
                    'Content-Type': 'application/json', 
                    apikey: this.nit.apikey,
                },
            };

            xaxios.request(config).then(function (response) {
                window.console.log('response', response);
                dialog.close();
                vue.initialize();
                let data = response.data.respuestaServicioFacturacion;
                let mensaje = 'Descripcion: ' + data.codigoDescripcion;

                vue.$root.$notify.show(mensaje, { color: 'success' });
            })
            .catch(function (error) {
                window.console.log(error);
                dialog.close();
                let data = error.response.data.respuestaServicioFacturacion;
                let mensaje = data.mensaje;
                let txt = data.codigoDescripcion;
                if (mensaje) txt += ` Error ${mensaje}`;
                else txt += ` ${data.mensajesList[0].codigo} - ${data.mensajesList[0].descripcion}`;
                vue.$root.$notify.show(txt, { color: 'red' });
            });
        },
        abrirAnularFactura(item) {
            let apikey = this.nit.apikey;
            this.$refs.anularfactura.openmodal(item,apikey);
        },
    },
    mounted(){ 
        // this.get_datos();
    }
}

</script>
